import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import BakeasyConfirmDialog, {
  BakeasyConfirmDialogProp
} from './components/dialogs/BakeasyConfirmDialog';
import { AppContext } from './context/AppContext';
import AppRoutes from './routes/AppRoutes';
import BakeasyDialog, { BakeasyDialogProp } from './components/dialogs/BakeasyDialog';
import { Provider } from 'react-redux';
import { store } from './redux_store/reduxStore';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import BakeasyLoaderRedux from './components/loaders/BakeasyLoaderRedux';
import BakeasySnackbarRedux from './components/common/BakeasySnackBarRedux';

const App = () => {
  const [dialog, setDialog] = useState<BakeasyDialogProp>({});
  const [confirmDialog, setConfirmDialog] = useState<BakeasyConfirmDialogProp>({});

  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AppContext.Provider value={{ dialog, setDialog, confirmDialog, setConfirmDialog }}>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <AppRoutes />
            <BakeasyLoaderRedux />
            <BakeasySnackbarRedux />
            <BakeasyDialog dialog={dialog} />
            <BakeasyConfirmDialog dialog={confirmDialog} />
          </BrowserRouter>
        </AppContext.Provider>
      </LocalizationProvider>
    </Provider>
  );
};

export default App;
